<div class="is-qr-code-container" #qrContainer></div>
